import useGetFavourites from "@/hooks/data/favourites/useGetFavourites";
import { createContext } from "react"

export interface IFavouritesContext extends ReturnType<typeof useGetFavourites> {
}

export const FavouritesContext = createContext<IFavouritesContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default FavouritesContext;